module.exports = __webpack_public_path__ + "static/img/icon_vip0.4084f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_vip0.png
// module id = Lj76
// module chunks = 192